import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui.min';

class Menu {
    static init() {
        const menu = document.querySelectorAll('.menu');
        if (menu.length) {
            menu.forEach((menu) => {
                Menu.bindMenu(menu);
            });
        }
    }

    static bindMenu(menu) {
        const items = menu.querySelectorAll('ul > li');

        items.forEach((li) => {
            if (li.querySelector('ul')) {
                li.addEventListener('click', (e) => {
                    if (li.classList.contains('active')) {
                        Menu.unselectEntry(menu, li);
                    } else {
                        Menu.selectEntry(menu, li);
                    }

                    e.stopPropagation();
                });
            }
        });
    }

    static selectEntry(menu, entry) {
        Menu.removeActive(menu, entry);
        entry.classList.add('active');
        Menu.render(menu);
    }

    static unselectEntry(menu, entry) {
        entry.classList.remove('active');
        Menu.render(menu);
    }

    static render(menu) {
        const items = menu.querySelectorAll('ul > li');

        items.forEach((li) => {
            const child = li.querySelector('ul');
            if (child) {
                if (!li.classList.contains('active') && child.style.display !== 'none') {
                    Velocity(child, 'slideUp', {
                        duration: 200,
                        easing: 'easeInOutQuad',
                        complete: () => {
                            child.style.display = 'none';
                        },
                    });
                }
                if (li.classList.contains('active') && child.style.display !== 'block') {
                    child.style.display = 'block';
                    Velocity(child, 'slideDown', { duration: 200, easing: 'easeInOutQuad' });
                }
            }
        });
    }

    static removeActive(menu, entry) {
        const items = menu.querySelectorAll('ul > li');

        items.forEach((li) => {
            if (!li.contains(entry)) {
                li.classList.remove('active');
            }
        });
    }
}

export default Menu;
